import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles';

const useStyles = createUseStyles(
  ({ spacing }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing.large,
    },
  }),
  { name: 'file-card-list' },
);

export default useStyles;
